import { useSearchParams } from 'react-router';
import ListPromo from './ListPromo';
import LayoutAdmin from '../../components/layouts/LayoutAdmin';
import FormPromo from './FormPromo';

export default function Promo() {
  const [searchParams] = useSearchParams();
  const activeTab = searchParams.get('tab') || 'list';

  return (
    <LayoutAdmin header="Promo">
      {activeTab === 'list' && <ListPromo />}
      {activeTab === 'form' && <FormPromo />}
    </LayoutAdmin>
  );
}
